/* assets/trepsa-step-sides.js — Schritt 3: Seitliche Abdeckungen */
(() => {
  "use strict";

  function esc(s) {
    return String(s ?? "")
      .replaceAll("&", "&amp;").replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;").replaceAll('"', "&quot;");
  }

  function init() {
    const root = document.querySelector("[data-trepsa-sides]");
    if (!root) return;

    let sideProduct = null;
    try {
      const sc = JSON.parse(root.querySelector("[data-sides-config]")?.textContent || "null");
      if (sc && sc.variantId && sc.variantId !== "null") sideProduct = sc;
    } catch { sideProduct = null; }

    const sidesWrap  = root.querySelector("[data-sides-list]");
    const addBtn     = root.querySelector("[data-sides-add]");
    const fields     = root.querySelector("[data-sides-fields]");
    const toggleBtns = root.querySelectorAll("[data-sides-toggle]");
    const calcEl     = root.querySelector("[data-sides-calc]");
    const qtyEl      = root.querySelector("[data-sides-qty]");

    const digits = (raw) => String(raw || "").replace(/[^\d]/g, "");

    function newSide() { return { count: 1, sides: "one" }; } // one | both

    const state = { active: false, sides: [newSide()] };

    function sideHTML(s, i) {
      return `
        <div class="trepsa-s4__entry" data-side-index="${i}">
          <div class="trepsa-s4__fieldRow">
            <div class="trepsa-s4__field">
              <label class="trepsa-s4__fieldLabel">Anzahl</label>
              <input class="trepsa-s4__input" type="text" inputmode="numeric" pattern="[0-9]*"
                placeholder="1" data-side-input="count" value="${esc(String(s.count || 1))}"
                style="max-width:120px;">
            </div>
          </div>
        </div>`;
    }
    function renderSides() { if (sidesWrap) sidesWrap.innerHTML = state.sides.map(sideHTML).join(""); }

    function calcSides() {
      if (!state.active || !sideProduct) return { qty: 0 };
      let qty = 0;
      for (const s of state.sides) {
        qty += Number(s.count) || 0;
      }
      return { qty };
    }

    function updateCalc() {
      if (!calcEl) return;
      const { qty } = calcSides();
      if (!state.active || !qty) { calcEl.style.display = "none"; return; }
      if (qtyEl) qtyEl.textContent = qty + "×";
      calcEl.style.display = "";
    }

    function emit() {
      const { qty } = calcSides();
      const priceCents = (sideProduct && qty) ? (Number(sideProduct.price || 0) * qty) : 0;
      const sides = state.active
        ? state.sides.filter(s => (Number(s.count) || 0) > 0).map(s => ({ count: Number(s.count) || 1, sides: s.sides }))
        : [];
      window.dispatchEvent(new CustomEvent("trepsa:sides:update", {
        detail: {
          active: state.active,
          sides,
          sideVariantId: sideProduct ? sideProduct.variantId : null,
          sideQty: qty,
          priceCents,
        }
      }));
    }

    function saveState() {
      try {
        localStorage.setItem("trepsa_sides", JSON.stringify({
          active: state.active,
          sides: state.sides.map(s => ({ count: s.count, sides: s.sides }))
        }));
      } catch (_) {}
    }

    function refresh() { updateCalc(); emit(); saveState(); }

    toggleBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const val = btn.getAttribute("data-sides-toggle") === "yes";
        state.active = val;
        toggleBtns.forEach((b) => b.setAttribute("aria-pressed", b === btn ? "true" : "false"));
        if (fields) fields.style.display = val ? "" : "none";
        if (!val) { state.sides = [newSide()]; renderSides(); }
        refresh();
      });
    });

    root.addEventListener("click", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      if (!t) return;

      const del = t.closest("[data-side-del]");
      if (del) {
        const i = Number(del.getAttribute("data-side-del"));
        if (state.sides.length > 1) { state.sides.splice(i, 1); renderSides(); refresh(); }
        return;
      }
    });

    root.addEventListener("input", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const input = t?.closest("[data-side-input]");
      if (!input) return;
      const idx = Number(t.closest("[data-side-index]")?.getAttribute("data-side-index"));
      const s = state.sides[idx];
      if (!s) return;
      const clean = digits(t.value);
      if (clean === "") { s.count = ""; t.value = ""; refresh(); return; }
      s.count = Math.max(1, Math.min(99, Number(clean) || 1));
      t.value = s.count;
      refresh();
    });

    // Leeres Anzahl-Feld beim Verlassen auf 1
    root.addEventListener("focusout", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const input = t?.closest('[data-side-input="count"]');
      if (!input) return;
      const idx = Number(t.closest("[data-side-index]")?.getAttribute("data-side-index"));
      const s = state.sides[idx];
      if (s && (s.count === "" || !Number(s.count))) {
        s.count = 1;
        input.value = "1";
        refresh();
      }
    });

    // Gespeicherten Zustand wiederherstellen
    (function restore() {
      try {
        const saved = JSON.parse(localStorage.getItem("trepsa_sides") || "null");
        if (saved && typeof saved === "object") {
          state.active = !!saved.active;
          if (Array.isArray(saved.sides) && saved.sides.length) {
            state.sides = saved.sides.map(s => ({ count: Number(s.count) || 1, sides: "one" }));
          }
          if (state.active) {
            toggleBtns.forEach((b) => b.setAttribute("aria-pressed", b.getAttribute("data-sides-toggle") === "yes" ? "true" : "false"));
            if (fields) fields.style.display = "";
          }
        }
      } catch (_) {}
    })();

    renderSides();
    refresh();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();